import { LocalKeyValueRepository, type KeyValueRepository } from '@/repositories/key-value'

export const STORAGE_KEYS = {
  profile: 'openelp-profile-v2',
  answers: 'openelp-answers-v2',
} as const
export interface PersistedData<T> { version: number; data: T }
export interface StorageService {
  get<T>(key: string): PersistedData<T> | null
  set<T>(key: string, data: T, version?: number): void
  remove(key: string): void
}

// 兼容前测旧接口；底层浏览器访问已统一进入 KeyValueRepository。
export class LocalStorageService implements StorageService {
  constructor(private readonly repository: KeyValueRepository = new LocalKeyValueRepository()) {}

  get<T>(key: string): PersistedData<T> | null {
    try {
      const raw = this.repository.get(key)
      if (!raw) return null
      const value = JSON.parse(raw) as PersistedData<T>
      return value && typeof value.version === 'number' && 'data' in value ? value : null
    } catch {
      return null
    }
  }

  set<T>(key: string, data: T, version = 1): void {
    const saved = this.repository.set(key, JSON.stringify({ version, data }))
    if (!saved) throw new Error(`无法保存本地数据：${key}`)
  }

  remove(key: string): void {
    this.repository.remove(key)
  }
}
